// const url = 'https://s78057p5p6.execute-api.us-east-1.amazonaws.com/dev';
// const url ='http://localhost:8000'
// const url ='http://localhost:3000'
const url = 'https://ja8fs66x77.execute-api.us-west-2.amazonaws.com/prod';
const llmUrl = 'https://t93gsz4ju9.execute-api.us-east-1.amazonaws.com/dev/api'
const chatSupportUrl = 'https://tawk.to/chat/67f4390204aaea190c0b1e66/1io8vtd6e';
const googleApiKey = 'AIzaSyCXu9degEWI9i7CnlTiqGk567YRw3AG2z0';
const app_version = 'V1.0 Beta'
const stripePublicKey = "pk_live_51RBFvk2N2PRLPu262CrWE55QrqynjZjgGhOrWuFIqDr4mCGYa1r3oqMvTWDTNmHYcL4pshWzVfVYXb1s7Gcpjxe200KRmovoLM";

export { url, llmUrl, googleApiKey, chatSupportUrl, app_version, stripePublicKey };